export class OnlineOrderLiveViewStatuses {
    private static _isPickupFilterValid(pickupDate: string) {
        return new Date().getTime() >= new Date(pickupDate).getTime();
    }

    public static isDone(
        orderData: OLO.DTO.OnlineOrderDetailedBusinessModel,
        deliveryStatus: OLO.Enums.DELIVERY_STATUS,
        liveViewSection: OLO.Config.OrderConfirmationPage.LiveViewItem,
        liveViewItems: OLO.Config.OrderConfirmationPage.LiveViewItem[],
    ): boolean {
        const isDone =
            (liveViewSection.statusFilter === null && liveViewSection.deliveryStatusFilter === null) ||
            liveViewItems.some((item) => OnlineOrderLiveViewStatuses.isActive(orderData, deliveryStatus, item) && item.displayIndex >= liveViewSection.displayIndex);

        if (liveViewSection.pickupDateFilter) {
            const pickupDateFilterValid = OnlineOrderLiveViewStatuses._isPickupFilterValid(orderData.PickUpDate);

            return pickupDateFilterValid && isDone;
        }

        return isDone;
    }

    public static isActive(
        orderData: OLO.DTO.OnlineOrderDetailedBusinessModel,
        deliveryStatus: OLO.Enums.DELIVERY_STATUS,
        liveViewSection: OLO.Config.OrderConfirmationPage.LiveViewItem,
    ): boolean {
        const isActive =
            (liveViewSection.statusFilter === null || liveViewSection.statusFilter.some((statusItem) => orderData.Status === statusItem)) &&
            (liveViewSection.deliveryStatusFilter === null || liveViewSection.deliveryStatusFilter.some((statusItem) => deliveryStatus === statusItem));

        if (liveViewSection.pickupDateFilter) {
            const pickupDateFilterValid = OnlineOrderLiveViewStatuses._isPickupFilterValid(orderData.PickUpDate);

            return pickupDateFilterValid && isActive;
        }

        return isActive;
    }

    public static isCompleted(
        orderData: OLO.DTO.OnlineOrderDetailedBusinessModel,
        deliveryStatus: OLO.Enums.DELIVERY_STATUS,
        liveViewSection: OLO.Config.OrderConfirmationPage.LiveViewItem,
        liveViewItems: OLO.Config.OrderConfirmationPage.LiveViewItem[],
    ): boolean {
        const isCompleted =
            (liveViewSection.statusFilter === null && liveViewSection.deliveryStatusFilter === null) ||
            liveViewItems.some((item) => OnlineOrderLiveViewStatuses.isActive(orderData, deliveryStatus, item) && item.displayIndex >= liveViewSection.displayIndex);

        if (liveViewSection.pickupDateFilter) {
            const pickupDateFilterValid = OnlineOrderLiveViewStatuses._isPickupFilterValid(orderData.PickUpDate);

            return pickupDateFilterValid && isCompleted;
        }

        return isCompleted;
    }

    public static isCancelled(
        orderData: OLO.DTO.OnlineOrderDetailedBusinessModel,
        deliveryStatus: OLO.Enums.DELIVERY_STATUS,
        liveViewSections: OLO.Config.OrderConfirmationPage.LiveViewItem[],
    ): boolean {
        return liveViewSections.some(
            (liveViewSection) =>
                liveViewSection.isFinal &&
                liveViewSection.isSuccess === false &&
                (liveViewSection.statusFilter?.includes(orderData.Status) || liveViewSection.deliveryStatusFilter?.includes(deliveryStatus)),
        );
    }

    /**
     * Create list of all actual statuses for current live view item element
     * @param order online order;
     * @param liveViewItem single live view item
     * @param liveViewItems all relevant live view items / context
     * @returns list of all relevant statuses
     */
    public static getSectionStatuses(
        order: OLO.DTO.OnlineOrderDetailedBusinessModel,
        deliveryStatus: OLO.Enums.DELIVERY_STATUS,
        liveViewItem: OLO.Config.OrderConfirmationPage.LiveViewItem,
        liveViewItems: OLO.Config.OrderConfirmationPage.LiveViewItem[],
    ): OLO.State.HistoryOrders.OrderLiveViewStatuses {
        return {
            isDone:
                OnlineOrderLiveViewStatuses.isDone(order, deliveryStatus, liveViewItem, liveViewItems) &&
                !liveViewItems.some((item) => OnlineOrderLiveViewStatuses.isDone(order, deliveryStatus, item, liveViewItems) && item.isFinal),
            isActive: OnlineOrderLiveViewStatuses.isActive(order, deliveryStatus, liveViewItem),
            isCompleted: OnlineOrderLiveViewStatuses.isCompleted(order, deliveryStatus, liveViewItem, liveViewItems),
            isCancelled: OnlineOrderLiveViewStatuses.isCancelled(order, deliveryStatus, liveViewItems),
            isFinal: liveViewItem.isFinal,
        };
    }
}
